import {
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';

interface CalendarSelectFormFieldProps {
  children: (props: {
    value: string | null;
    onChange: (value: string | null) => void;
  }) => ReactNode;
}

export function CalendarSelectFormField({
  children,
}: CalendarSelectFormFieldProps) {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();

  return (
    <FormField
      control={form.control}
      name="terminKalenderId"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('domain.termine.terminCalendar')}</FormLabel>
          {children({ value: field.value || null, onChange: field.onChange })}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
